import type { CatalogTree } from '../types';

// AI quality (admin panel screens §3.9).
export const aiQuality = {
  title: 'Yapay zekâ kalitesi',
  tabsLabel: 'Yapay zekâ kalitesi bölümleri',
  tabs: {
    models: 'Model ayarları',
    evaluations: 'Değerlendirmeler',
    samples: 'Konuşma örnekleri',
    gaps: 'Cevaplanamayan sorular',
  },
  dimensions: {
    product_identification: 'Ürün tanıma',
    price_grounding: 'Fiyat dayanağı',
    handoff_decisions: 'Aktarma kararları',
    guardrail_violations: 'Kural ihlali',
    latency: 'Gecikme (p95)',
  },
  engines: { scripted: 'Betikli', llm: 'LLM' },
  yes: 'Evet',
  no: 'Hayır',
  models: {
    engine: 'Motor',
    tasks: {
      chat_model: 'Sohbet modeli',
      vision_model: 'Görüntü modeli',
      embedding_model: 'Gömme modeli',
    },
    provider: 'Sağlayıcı',
    model: 'Model',
    fallback: 'Yedek',
    useFallback: 'Yedek kullan',
    embeddingWarning:
      'Gömme modelini değiştirmek görsel dizini geçersiz kılar; farklı sürümlerin vektörleri karşılaştırılmaz.',
    thresholds: 'Görsel eşleme eşikleri',
    thresholdsFor: 'Gömme modeli: {model}',
    exact: 'Birebir eşleşme eşiği',
    similar: 'Benzer eşleşme eşiği',
    autoLink: 'Otomatik bağlama eşiği',
    footer: 'Değişiklikleri önce değerlendirme setinde çalıştırın',
    save: 'Kaydet',
    confirmTitle: 'Model ayarlarını kaydet',
    confirmText: 'Bu ayarlar tüm işletmelerin yanıtlarını etkiler.',
  },
  evaluations: {
    sets: 'Test setleri',
    runs: 'Çalıştırmalar',
    sources: { synthetic: 'Sentetik', anonymised_real: 'Anonim gerçek' },
    builtIn: 'Yerleşik',
    setColumns: {
      name: 'Ad',
      version: 'Sürüm',
      source: 'Kaynak',
      cases: 'Vaka',
      builtIn: 'Tür',
      baseline: 'Temel çalıştırma',
      importedBy: 'İçe aktaran',
      created: 'Oluşturulma',
    },
    runColumns: {
      set: 'Set',
      engine: 'Motor',
      status: 'Durum',
      result: 'Geçen / kalan',
      regression: 'Gerileme',
      triggeredBy: 'Başlatan',
      started: 'Başlangıç',
      duration: 'Süre',
    },
    setVersion: '{name} v{version}',
    passedFailed: '{passed} / {failed}',
    emptyRuns: 'Henüz çalıştırma yok. Yerleşik seti çalıştırın.',
    emptySets: 'Henüz test seti yok.',
    run: 'Çalıştır',
    setBaseline: 'Temel al',
    import: 'İçe aktar',
    runSheet: {
      title: 'Değerlendirme çalıştır',
      set: 'Test seti',
      engine: 'Motor',
      baseline: 'Temel çalıştırma',
      noBaseline: 'Yok',
      tolerances: 'Toleranslar',
    },
    importSheet: {
      title: 'Test seti içe aktar',
      notice:
        'Gerçek konuşmalar yalnızca anonimleştirilmiş ve incelenmiş olarak içe aktarılır; telefon, e-posta, IBAN veya kimlik numarası içeren dosya reddedilir.',
      file: 'JSON dosyası seç',
      noFile: 'Dosya seçilmedi.',
      invalidJson: 'Dosya geçerli bir JSON değil.',
      errors: 'Dosya doğrulanamadı:',
    },
  },
  run: {
    notFound: 'Böyle bir çalıştırma yok.',
    backToList: 'Değerlendirmelere dön',
    regressed: 'Temel çalıştırmaya göre gerileyen boyutlar: {dimensions}',
    snapshot: 'Model ayarları',
    scores: 'Puanlar',
    scoreColumns: {
      dimension: 'Boyut',
      value: 'Değer',
      target: 'Hedef',
      baseline: 'Temel',
      delta: 'Fark',
      tolerance: 'Tolerans',
      met: 'Hedefte',
    },
    cases: 'Vaka sonuçları',
    caseColumns: {
      key: 'Vaka',
      tags: 'Etiketler',
      mode: 'Mod',
      passed: 'Geçti',
      latency: 'Gecikme (ms)',
      units: 'Birim',
    },
    modes: { engine: 'Motor', end_to_end: 'Uçtan uca' },
    error: 'Hata',
    checks: 'Kontroller',
    checkColumns: { name: 'Kontrol', expected: 'Beklenen', actual: 'Gerçekleşen' },
    output: 'Çıktı',
    compare: 'Karşılaştır',
    comparison: 'Karşılaştırma',
    compareColumns: { run: 'Bu çalıştırma', against: 'Karşılaştırılan' },
    passToFail: 'Geçerken kalanlar',
    failToPass: 'Kalırken geçenler',
    none: 'Yok',
  },
  samples: {
    notice:
      'Bu ekrandaki her örnekleme ve her açılan konuşma, gerekçenizle birlikte denetim kaydına yazılır.',
    reason: 'Gerekçe',
    merchant: 'İşletme',
    merchantPlaceholder: 'Tüm işletmeler',
    merchantEmpty: 'İşletme bulunamadı.',
    channel: 'Kanal',
    verdict: 'Sonuç',
    verdicts: { reply: 'Asistan yanıtı', handoff: 'Personele aktarma', none: 'Yanıt yok' },
    handoffReason: 'Aktarma nedeni',
    all: 'Tümü',
    dateRange: 'Tarih aralığı',
    since: 'Başlangıç',
    until: 'Bitiş',
    size: 'Örnek sayısı',
    sizeRange: '1 ile 50 arasında bir sayı girin.',
    submit: 'Örnekle',
    results: 'Örneklenen konuşmalar',
    empty: 'Bu filtreye uyan konuşma yok.',
    open: 'Aç',
    back: 'Geri',
    redacted: 'Anonimleştirilmiş görünüm',
    reasonNeeded: 'Bu konuşmayı açmak için bir gerekçe girin.',
    transcriptTitle: '{merchant} konuşması',
  },
  gaps: {
    chart: 'Günlük cevaplanamayan soru',
    count: 'Soru',
    topics: 'En sık konular',
    columns: {
      topic: 'Konu',
      question: 'Soru',
      count: 'Sayı',
      merchants: 'İşletme',
      trend: 'Önceki döneme göre',
      lastAsked: 'Son soru',
    },
    noTopic: 'Konusuz',
    day: 'Gün',
    trendValue: '{previous} → {count}',
    note: 'Cevaplar işletme panelinde, Asistan → Boşluklar altında eklenir.',
    empty: 'Bu dönemde cevaplanamayan soru yok.',
  },
} as const satisfies CatalogTree;
